import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "pl-4 pt-2" }

import { SELECTABLE_WORK_EVENT_TYPE } from '@/services/consts/operation_office';
import { watch, computed } from 'vue'
import i18n from '@/lang/i18n';


export default /*@__PURE__*/_defineComponent({
  __name: 'AllocatedWorkFrom',
  props: {
    modelValue: {},
    errors: {},
    windowInnerWidth: {}
  },
  emits: ['update:modelValue'],
  setup(__props: any, { emit: __emit }) {

const emit = __emit

const props = __props


const modelValue = computed({
  get() {
    return props.modelValue
  },
  set(value) {
    emit("update:modelValue", value)
  }
})

watch(() => props.modelValue.is_active_allocated, (newVal) => {
  if (!newVal) {
    modelValue.value.allocated_minute = null;
    modelValue.value.allocated_work = '';
  }
}, { deep: true })

return (_ctx: any,_cache: any) => {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_switch = _resolveComponent("v-switch")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_row = _resolveComponent("v-row")!

  return (_openBlock(), _createBlock(_component_v_row, { class: "text-form pl-4 pr-3 mb-3 align-center" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_col, { cols: "2" }, {
        default: _withCtx(() => [
          _createElementVNode("h6", _hoisted_1, _toDisplayString(_unref(i18n).global.t('pages.operationOffices.form.allocatedWork.title')), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_v_col, { cols: "9" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_row, { class: "align-center" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, { cols: "1" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_switch, {
                    modelValue: modelValue.value.is_active_allocated,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((modelValue.value.is_active_allocated) = $event)),
                    color: "blue",
                    "hide-details": "auto"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, { cols: "4" }, {
                default: _withCtx(() => [
                  _withDirectives(_createVNode(_component_v_text_field, {
                    label: _unref(i18n).global.t('pages.operationOffices.form.allocatedWork.time'),
                    modelValue: modelValue.value.allocated_minute,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((modelValue.value.allocated_minute) = $event)),
                    suffix: _unref(i18n).global.t('pages.operationOffices.form.allocatedWork.stoppingMoreThanMinutes'),
                    class: "mt-0",
                    maxlength: "5",
                    "hide-details": "auto",
                    "error-messages": __props.errors['allocated_minute']
                  }, null, 8, ["label", "modelValue", "suffix", "error-messages"]), [
                    [_vShow, modelValue.value.is_active_allocated]
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, { cols: "4" }, {
                default: _withCtx(() => [
                  _withDirectives(_createVNode(_component_v_select, {
                    label: _unref(i18n).global.t('pages.operationOffices.form.allocatedWork.work'),
                    items: _unref(SELECTABLE_WORK_EVENT_TYPE),
                    "item-value": "value",
                    "item-title": "name",
                    modelValue: modelValue.value.allocated_work,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((modelValue.value.allocated_work) = $event)),
                    "hide-details": "auto",
                    "error-messages": __props.errors['allocated_work']
                  }, null, 8, ["label", "items", "modelValue", "error-messages"]), [
                    [_vShow, modelValue.value.is_active_allocated]
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})